export default {
  show(msg, type, time) {
    const me = this;
    document.body.insertAdjacentHTML(
      'beforeend',
      `<div class="activity-toast-box">
        <div class="activity-toast">
          <div class="activity-toast-img ${type}"></div>
          <div class="activity-toast-txt">${msg}</div>
        </div>
        <div class="activity-toast-mask"></div>
      </div>`,
    );

    setTimeout(() => {
      me.hide();
    }, time || 2000);
  },

  hide() {
    if (document.querySelector('.activity-toast-box')) {
      document
        .querySelector('.activity-toast-box')
        .parentNode.removeChild(document.querySelector('.activity-toast-box'));
    }
  },
};
